export default __webpack_public_path__ + "static/stars_small-68cd008f178897cd0bd4e9753fda0d92.png";